import React from "react"
import { SyncLoader } from "react-spinners"


const Loader = () => {
   /*  return (
        <div
            style={{
                display : "flex",
                justifyContent : "center",
                alignItems : "center",
                width : "100%",
                height : "100%"
            }}
        >
            <img id="loader-gif" src={"./Assets/Spinner-3.gif"} />
        </div>
    ) */

        return <SyncLoader
        color={"#89272D"}
        speedMultiplier={0.5}
        size={20}
        aria-label="Loading Spinner"
        data-testid="loader"
      />

}

export default Loader